import { cva } from 'class-variance-authority';

export const dialogBackdropClasses = cva(
  'fixed top-0 right-0 bottom-0 left-0 z-[var(--z-backdrop)] flex items-center justify-center',
  {
    variants: {
      hideBackdrop: {
        true: '',
        false: 'bg-charcoal-alpha-400'
      }
    }
  }
);

export const dialogWrapperClasses = cva(
  [
    'bg-white-50 border-charcoal-alpha-50 absolute right-4 bottom-4 left-4 z-[var(--z-dialog)] flex max-h-[calc(100dvh-var(--spacing-4))] flex-col overflow-hidden rounded-2xl border-1 shadow-[0px_4px_24px_rgba(0,0,0,0.475)]',
    'md:top-0 md:right-0 md:bottom-0 md:left-0 md:m-auto md:h-fit'
  ],
  {
    variants: {
      size: {
        small: 'md:max-w-[458px]',
        medium: 'md:max-h-[780px] md:max-w-[578px]',
        large: 'md:max-w-[696px]',
        full: 'md:max-w-[calc(100dvw-var(--spacing-16))]'
      }
    },
    defaultVariants: {
      size: 'medium'
    }
  }
);

export const dialogHeaderClasses = cva([
  'flex flex-none flex-row items-start justify-between gap-1 p-4 pb-2'
]);

export const dialogContentClasses = cva([
  'flex min-h-[80px] flex-1 flex-col overflow-y-auto px-4 py-2'
]);

export const dialogFooterClasses = cva([
  'border-charcoal-alpha-50 flex flex-col gap-3 border-t-1 border-solid p-4 md:flex-col-reverse'
]);
